import { render } from "./ResponseChartWrapper.vue?vue&type=template&id=9aa38b26"
import script from "./ResponseChartWrapper.vue?vue&type=script&lang=js"
export * from "./ResponseChartWrapper.vue?vue&type=script&lang=js"
script.render = render

export default script